import { Tabs, Wrapper } from '@cma/common'
import AdminBrandHub from '@cma/features/admin/account/brand/AdminBrandHub'
import AdminContent from '@cma/features/admin/account/content/AdminContent'
import AdminRoster from '@cma/features/admin/account/roster/AdminRoster'
import AdminUsageStats from '@cma/features/admin/account/usage/AdminUsageStats'

export default function AdminPanel() {
  return (
    <Wrapper>
      <main>
        <Tabs
          onChange={() => {}}
          className="mx-auto flex w-full max-w-[960px] flex-col items-center justify-between">
          <Tabs.List className="flex w-full gap-2.5 pl-3">
            <Tabs.Tab>Content</Tabs.Tab>
            <Tabs.Tab>Brand Hub</Tabs.Tab>
            <Tabs.Tab>Roster</Tabs.Tab>
            <Tabs.Tab>Usage</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panels className="w-full rounded-lg bg-white p-4 py-6 shadow md:p-6">
            <Tabs.Panel>
              <AdminContent />
            </Tabs.Panel>
            <Tabs.Panel>
              <AdminBrandHub />
            </Tabs.Panel>
            <Tabs.Panel>
              <AdminRoster />
            </Tabs.Panel>
            <Tabs.Panel>
              <AdminUsageStats />
            </Tabs.Panel>
          </Tabs.Panels>
        </Tabs>
      </main>
    </Wrapper>
  )
}
